import React from "react";

import { createBrowserRouter } from "react-router-dom";

import Home from "@/components/Home";
import Dashboard from "@/components/Dashboard";
import Login from "@/components/Login";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import Logout from "@/components/Logout";
import Register from "@/components/Register";
import MortgageShareRegister from "@/components/pages/MonthlyBoost/MortgageShareRegister";
import UpfrontBoost from "@/components/pages/UpfrontBoost/UpfrontBoost";
import DoubleBoost from "@/components/pages/DoubleBoost/DoubleBoost";
import MortgageShareFlow from "@/components/pages/MortgageShareFlow/MortgageShareFlow";
import MonthlyBoost from "@/components/pages/MonthlyBoost/MonthlyBoost";
import UpfrontBoostRegister from "@/components/pages/UpfrontBoost/UpfrontBoostRegister";
import UpfrontBoostCalculator from "@/components/pages/UpfrontBoost/UpfrontBoostCalculator";
import BuyingBoostRegister from "@/components/pages/DoubleBoost/BuyingBoostRegister";
import About from "@/components/pages/About";
import FAQ from "@/components/pages/FAQ";
import MonthlyBoostCalculator from "@/components/pages/MonthlyBoost/MonthlyBoostCalculator";
import DoubleBoostCalculator from "@/components/pages/DoubleBoost/DoubleBoostCalculator";
import ApplicationUser from "@/components/pages/Application/ApplicationUser";
import ApplicationContinue from "@/components/pages/Application/ApplicationContinue";
import ProductLayout from "@/components/layouts/product/ProductLayout";
import MainLayout from "@/components/layouts/MainLayout";
import ApplicationContext from "@/components/pages/Application/ApplicationContext";
import Privacy from "@/components/pages/Privacy";
import TermsOfUse from "@/components/pages/TermsOfUse";
import ApplicationApplicantWrapper from "@/components/pages/Application/ApplicationApplicantWrapper";
import ApplicantAddressWrapper from "@/components/pages/Application/ApplicantAddressWrapper";
import ApplicantIDWrapper from "@/components/pages/Application/ApplicantIDWrapper";
import ApplicantCurrentMortgageWrapper from "@/components/pages/Application/ApplicantCurrentMortgageWrapper";
import ApplicantEmploymentWrapper from "@/components/pages/Application/ApplicantEmploymentWrapper";
import ApplicantLiabilitiesWrapper from "@/components/pages/Application/ApplicantLiabilitiesWrapper";
import ApplicantAssetsWrapper from "@/components/pages/Application/ApplicantAssetsWrapper";
import BankingDetailsWrapper from "@/components/pages/Application/BankingDetailsWrapper";
import SelfDeclarationWrapper from "@/components/pages/Application/SelfDeclarationWrapper";
import ApplicantChecksLayout from "@/components/layouts/product/ApplicantChecksLayout";
import HomeBusiness from "@/components/HomeBusiness";
import ForBusiness from "@/components/pages/ForBusiness/ForBusiness";
import BuyNowPayLater from "@/components/pages/BNPL/BuyNowPayLater";
import ContactUs from "@/components/pages/ContactUs";
import DebtFree from "@/components/pages/DebtFree/DebtFree";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/pages/Admin/AdminLayout";
import AdminUsers from "@/components/pages/Admin/AdminUsers";
import AdminApplications from "@/components/pages/Admin/AdminApplications";
import AdminEnquiries from "@/components/pages/Admin/AdminEnquiries";
import AdminEnquiry from "@/components/pages/Admin/AdminEnquiry";
import AdminDocumentTypes from "@/components/pages/Admin/AdminDocumentTypes";
import SiteLayout from "@/components/layouts/SiteLayout";
import HowItWorks from "@/components/pages/HowItWorks";
import GetStarted from "@/components/pages/GetStarted/GetStarted";

const AppNavigation = createBrowserRouter([
  {
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "/how-it-works",
        element: <HowItWorks />,
      },
      {
        path: "/faq",
        element: <FAQ />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/get-started",
        element: <GetStarted />,
      },
      {
        path: "/contact-us",
        element: <ContactUs />,
      },
    ],
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: "/business",
        element: <HomeBusiness />,
      },
      {
        path: "/terms-of-use",
        element: <TermsOfUse />,
      },
      {
        path: "/privacy-policy",
        element: <Privacy />,
      },
      {
        path: "/application/from-email/:id",
        element: <ApplicationContinue />,
      },
      {
        path: "/application",
        element: <ProtectedRoute />,
        children: [
          {
            element: <ProductLayout />,
            children: [
              {
                path: "/application/:id/user",
                element: <ApplicationUser />,
              },
              {
                path: "/application/:id/context",
                element: <ApplicationContext />,
              },
              {
                path: "/application/:id/applicant/:type",
                element: <ApplicationApplicantWrapper />,
              },
              {
                path: "/application/:id",
                element: <ApplicantChecksLayout />,
                children: [
                  {
                    path: "/application/:id/applicant-address/:type",
                    element: <ApplicantAddressWrapper />,
                  },
                  {
                    path: "/application/:id/applicant-id/:type",
                    element: <ApplicantIDWrapper />,
                  },
                  {
                    path: "/application/:id/applicant-employment/:type",
                    element: <ApplicantEmploymentWrapper />,
                  },
                ],
              },
              {
                path: "/application/:id/applicant-current-mortgage/:type",
                element: <ApplicantCurrentMortgageWrapper />,
              },
              {
                path: "/application/:id/liabilities/:type",
                element: <ApplicantLiabilitiesWrapper />,
              },
              {
                path: "/application/:id/assets/:type",
                element: <ApplicantAssetsWrapper />,
              },
              {
                path: "/application/:id/banking-details",
                element: <BankingDetailsWrapper />,
              },
              {
                path: "/application/:id/self-declaration",
                element: <SelfDeclarationWrapper />,
              },
              {
                path: "/application/",
              },
            ],
          },
        ],
      },
      {
        path: "/business/for-business",
        element: <ForBusiness />,
      },
      {
        path: "/business/bnpl",
        element: <BuyNowPayLater />,
      },
      {
        path: "/monthly-boost",
        children: [
          {
            index: true,
            element: <MonthlyBoost />,
          },
          {
            path: "/monthly-boost/register",
            element: <MortgageShareRegister />,
          },
          {
            path: "/monthly-boost/calculator",
            element: <MonthlyBoostCalculator />,
          },
        ],
      },
      {
        path: "/upfront-boost",
        children: [
          {
            index: true,
            element: <UpfrontBoost />,
          },
          {
            path: "/upfront-boost/register",
            element: <UpfrontBoostRegister />,
          },
          {
            path: "/upfront-boost/calculator",
            element: <UpfrontBoostCalculator />,
          },
        ],
      },
      {
        path: "/double-boost",
        children: [
          {
            index: true,
            element: <DoubleBoost />,
          },
          {
            path: "/double-boost/register",
            element: <BuyingBoostRegister />,
          },
          {
            path: "/double-boost/calculator",
            element: <DoubleBoostCalculator />,
          },
        ],
      },
      {
        path: "/debt-free-partnership",
        children: [
          {
            index: true,
            element: <DebtFree />,
          },
        ],
      },
      {
        path: "/dashboard",
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: "/dashboard/mortgage-share/:id",
            element: <MortgageShareFlow />,
          },
        ],
      },
      {
        path: "/admin",
        element: <ProtectedRoute />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              {
                index: true,
                element: <AdminUsers />,
              },
              {
                path: "/admin/users",
                element: <AdminUsers />,
              },
              {
                path: "/admin/applications",
                element: <AdminApplications />,
              },
              {
                path: "/admin/enquiries",
                element: <AdminEnquiries />,
              },
              {
                path: "/admin/enquiries/:id",
                element: <AdminEnquiry />,
              },
              {
                path: "/admin/document-types",
                element: <AdminDocumentTypes />,
              },
            ],
          },
        ],
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
    ],
  },
]);

export default AppNavigation;
